<template>
  <vx-card :title="$t('reports.demographics.'+category+'.title')">
    <vs-row vs-align="center" vs-justify="center">
      <vs-col vs-w="2" v-if="pieChart">
        <vue-apex-charts type="pie" :options="pieChart.chartOptions" :series="pieChart.series"/>
      </vs-col>
      <vs-col vs-w="10" v-if="heatMapChart">
        <vs-row>
          <vs-col vs-w="12">
            <vue-apex-charts type="heatmap" height="350" :options="heatMapChart.chartOptions" :series="heatMapChart.series"></vue-apex-charts>
          </vs-col>
        </vs-row>
      </vs-col>
    </vs-row>
  </vx-card>
</template>

<script>
import StatisticsCardLine from '@/components/statistics-cards/StatisticsCardLine';

export default {
  name: 'demographics-category-card',
  components: {StatisticsCardLine},
  props: {
    data: Object,
    category: String,
    colors: {
      type: Array,
      default () {
        return ['#19aef6'];
      }
    }
  },
  data () {
    return {
      pieChart: null,
      // histogram: null,
      heatMapChart: null
    };
  },
  watch: {
    data: {
      immediate: true,
      handler (value) {
        const root = value.analysis.find(n => n.name === 'ROOT');
        const allTime = root.nested.find(n => n.name === 'ALL_TIME');
        const category = allTime.nested.find(n => n.name === this.category);
        this.pieChart = {
          series: category.buckets.map(b => b.count),
          chartOptions: {
            chart: {
              type: 'pie'
            },
            colors: this.colors,
            labels: category.buckets.map(b => {
              const key = `reports.demographics.${this.category}.values.${b.key}`;
              return this.$te(key) ? this.$t(key) : b.key;
            }),
            plotOptions: {
              pie: {
                dataLabels: {
                  offset: -10,
                  minAngleToShowLabel: 20
                }
              }
            },
            dataLabels: {
              enabled: true,
              formatter (val) {
                return `${val.toFixed(1)} %`;
              }
            },
            legend: {
              show: false
            }
          }
        };

        const series = [];
        category.buckets.forEach(categoryBucket => {
          const serie = {
            name: categoryBucket.key,
            data: []
          };
          if (!categoryBucket.nested || !categoryBucket.nested.find(n => n.name === 'AGE')) {
            return;
          }
          const age = categoryBucket.nested.find(n => n.name === 'AGE');
          if (age) {
            age.buckets.sort((a, b) => {
              if (a.key < b.key) {
                return -1;
              }
              if (a.key > b.key) {
                return 1;
              }
              return 0;
            }).forEach(ageBucket => {
              serie.data.push({
                x: ageBucket.key,
                y: ageBucket.count
              });
            });
          }
          series.push(serie);
        });

        this.heatMapChart = {
          series,
          chartOptions: {
            chart: {
              toolbar: {
                show: false
              }
            },
            colors: this.colors,
            dataLabels: {
              enabled: false
            },
            legend: {
              show: false
            },
            yaxis: {
              title: {
                show: false
              },
              labels: {
                align: 'right',
                minWidth: 240,
                maxWidth: 240,
                formatter: (value) => {
                  const key = `reports.demographics.${this.category}.values.${value}`;
                  return this.$te(key) ? this.$t(key) : value;
                }
              }
            },
            xaxis: {
              title: {
                text: this.$t('reports.demographics.age')
              }
            }
          }
        };
      }
    }
  }
};
</script>

<style scoped>

</style>
